import { parseResponseError } from '@/utils/api';
import { isSubscriberPortalPath } from '@/utils/subscriberSession';

/**
 * O `onError` padrão das queries do painel: o toast de erro com a frase do backend.
 *
 * Mora fora do `Router` para os testes de jornada montarem o mesmo QueryClient do app. Sem ele,
 * uma query que falha em silêncio no teste vira toast vermelho em produção, e foi assim que o 403
 * do piloto da nota avulsa chegou à home de todo produtor.
 *
 * Query cujo erro já aparece na tela declara o próprio `onError`, que substitui este.
 */
export const createQueryErrorToast = (notify) => (error) => {
  const currentPath = window.location.pathname;

  // O portal do assinante mostra a falha de carga na própria tela, com "tentar de novo"; o
  // toast daqui por cima repetiria o erro como "Erro interno do servidor", até em queda de
  // rede. As mutations de lá têm `onError` próprio, que substitui o daqui.
  if (isSubscriberPortalPath(currentPath)) {
    return;
  }

  const isPublicRoute =
    currentPath.startsWith('/mcp') ||
    currentPath.startsWith('/refund') ||
    currentPath.startsWith('/subscriptions') ||
    currentPath.startsWith('/auth') ||
    currentPath.startsWith('/survey') ||
    currentPath.startsWith('/affiliate/invite') ||
    currentPath.startsWith('/p/');

  const status = error?.response?.status;
  const isUnauthorizedError = status === 401 || status === 403;
  const isNotFoundError = status === 404;

  if (isPublicRoute && isUnauthorizedError) {
    return;
  }

  if (isNotFoundError) {
    return;
  }

  const isFeePreviewMaxPrice =
    error?.config?.url?.includes('fee_preview') && error?.response?.data?.base_amount;
  if (isFeePreviewMaxPrice) {
    const isFlowV2 = window.location.search.includes('flow=v2');
    if (isFlowV2) {
      notify.error('Erro ao adicionar um novo produto');
    }
    return;
  }

  const { message } = parseResponseError(error);
  notify.error(message);
};
